/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import {
  CheckCircleOutlined,
  QuestionCircleOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons'
import colors from '@sportninja/common/constants/appColors'
import { status } from '@sportninja/common/constants/attendanceStatus'
import { Tooltip } from 'antd'
import React from 'react'
import { MODAL_TOKENS } from 'src/styles/modalTokens'
import {
  ATTENDANCE_STATUS_COPY_KEY_BY_VALUE,
  getAttendanceStatusTooltip,
} from '../utils/statusCopy'

const ICONS = [
  {
    value: status.ATTENDING,
    Icon: CheckCircleOutlined,
    color: colors.SUCCESS_300,
  },
  {
    value: status.MAYBE,
    Icon: QuestionCircleOutlined,
    color: colors.WARNING_300,
  },
  {
    value: status.NOT_ATTENDING,
    Icon: CloseCircleOutlined,
    color: colors.ERROR_300,
  },
]

export interface AttendanceAvailIconsProps {
  attendanceStatus?: number | null
  disabled?: boolean
  yesNoOnly?: boolean
  onPress: (next: number | null) => void
}

const rowStyle = css`
  display: flex;
  align-items: center;
  gap: 12px;
`
const iconStyle = (active: boolean, color: string, disabled?: boolean) => css`
  font-size: 20px;
  cursor: ${disabled ? 'not-allowed' : 'pointer'};
  color: ${active ? color : colors.NEUTRAL_100};
  opacity: ${disabled ? 0.5 : 1};
`

const AttendanceAvailIcons: React.FC<AttendanceAvailIconsProps> = ({
  attendanceStatus,
  disabled = false,
  yesNoOnly = false,
  onPress,
}) => {
  const icons = ICONS.filter((i) => !yesNoOnly || i.value !== status.MAYBE)
  return (
    <div css={rowStyle}>
      {icons.map(({ value, Icon, color }) => {
        const active = attendanceStatus === value
        const tooltip = getAttendanceStatusTooltip(
          ATTENDANCE_STATUS_COPY_KEY_BY_VALUE[value]
        )
        return (
          <Tooltip
            key={value}
            title={tooltip}
            zIndex={MODAL_TOKENS.Z_INDEX_TOOLTIP}
          >
            <Icon
              css={iconStyle(active, color, disabled)}
              aria-label={tooltip}
              onClick={() => {
                if (disabled) {
                  return
                }
                onPress(active ? null : value)
              }}
            />
          </Tooltip>
        )
      })}
    </div>
  )
}

export default AttendanceAvailIcons
